require('jquery-validation/dist/jquery.validate')

export const msEmailDomains = ['outlook.jp', 'outlook.com', 'hotmail.com', 'live.com', 'live.jp', 'msn.com', 'hotmail.co.jp'];

// パスワードチェック用
jQuery.validator.addMethod('password', function (value, element) {
  return this.optional(element) || /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9]{8,128}$/.test(value);
}, '半角英数字・大文字含む、8文字以上で入力してください');

// ファイル上限チェック用
jQuery.validator.addMethod('fileSize', function (value, element, params) {
  var file = element.files[0];
  if (!file) {
    return this.optional(element);
  }
  return this.optional(element) || file.size < params;
}, 'ファイルサイズを{0}Byte以下にしてください');

// 半角英字のみ
jQuery.validator.addMethod('alphabet', function (value, element) {
  return this.optional(element) || /^[a-zA-Z ]+$/.test(value);
}, '半角英字のみで入力してください');

// 全角カナのみ
jQuery.validator.addMethod('katakana', function (value, element) {
  return this.optional(element) || /^[ァ-ヶー　]+$/.test(value);
}, 'カタカナで入力してください');

// 比較
jQuery.validator.addMethod('greaterThan', function (value, element, params) {
  var target = $(params);
  if (!target.val()) {
    return true;
  }
  if (!value) {
    return true;
  }
  return this.optional(element) || target.val() < value;
}, 'より大きい値を入力してください');

// 誕生日用 3つのプルダウンのうち、全部入力しないか全部入力するかのどちらかのみ許可
jQuery.validator.addMethod('allOrNothing', function (value, element, params) {
  var target = $(params);
  var values = target.map(function (index, element) {
    return !!$(element).val();
  });
  if (values.get().every(function (value) { return !value })) {
    // 全値が空の場合
    return true;
  }
  if (values.get().every(function (value) { return value })) {
    // 全値が入力の場合
    return true;
  }
  return false;
}, '入力する場合はすべて入力してください');

// 誕生日用 日付が昨日以前であるかのチェック
jQuery.validator.addMethod('lessThanNow', function (value, element, params) {
  const target = $(params);
  const values = {};
  target.each(function (index, element) {
    const value = $(element).val();
    const name = $(element).attr('name');
    if (value) {
      let key = '';
      if (name.includes('[day]')) {
        key = 'day';
      } else if (name.includes('[month]')) {
        key = 'month';
      } else {
        key = 'year'
      }
      values[key] = Number.parseInt(value);
    }
  });
  if (Object.keys(values).length === 3) {
    // 全値が入力の場合
    const date = new Date(values.year, values.month - 1, values.day);
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    return this.optional(element) || date < today;
  }
  return this.optional(element);
}, 'は過去の日付を入力してください');

// 郵便番号
jQuery.validator.addMethod('postalCode', function (value, element) {
  return this.optional(element) || /^[0-9]{3}-?[0-9]{4}$/.test(value);
}, '郵便番号形式で入力してください');

// 日本形式の電話番号
jQuery.validator.addMethod('jpPhoneNumber', function (value, element) {
  return this.optional(element) || /^0[0-9]{9,10}$/.test(value);
}, '半角数字で入力してください');

// 選択肢
jQuery.validator.addMethod('in', function (value, element, params) {
  return this.optional(element) || params.indexOf(value) !== -1
}, '選択が正しくありません');

// microsoft以外のメールアドレス
jQuery.validator.addMethod('withoutMicrosoftDomains', function (value, element) {
  const emailDomain = value.split('@')[1];
  return this.optional(element) || !msEmailDomains.includes(emailDomain);
}, `には${msEmailDomains.join('、')}のメールアドレスは使用できません。`);

// 寄付金額の上限 使途ごとの金額の合計が一定以下であるチェック
// paramsは{ target: target, limit: limit }の形式で渡す
jQuery.validator.addMethod('donationAmountLimit', function (value, element, params) {
  const target = $(params.target);
  let total = 0;
  target.each(function (index, element) {
    total += Number.parseInt($(element).val());
  });
  console.log(total);
  return this.optional(element) || total <= params.limit;
}, '寄付金額の合計は9,999,999円以下で入力してください');
